<template>
    <div>
        <legend>Rollen</legend>
        
        <div class="pure-g" v-if="!readonly">
            <div id="roleBox" class="pure-u-4-24">
                <select id="role" v-model="selectedRole">
                    <option v-for="role in  allRoles" :key="role">{{ role }}</option>
                </select>
            </div>
            <div class="pure-u-8-24">
                <vue-single-select  style="height: 3rem;"
                        v-model="selectedCustomer"
                        :options="allCustomers"
                        :required="false"
                        placeholder="Suchen ..."
                        
                ></vue-single-select>
            </div>
            <div id="addRoleBox" class="pure-u-3-24">
                <a v-on:click="addCustomerRole">Hinzuf&uuml;gen</a>
            </div>
        </div>
        <div class="pure-g">
            <div id="roleBox" class="pure-u-15-24">
            <table id="tableCustomerRole" class="pure-table table">
            <thead>
                <tr> 
                    <th>Rolle</th>
                    <th>Kunde</th>
                    <th class="colAction" v-if="!readonly"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(accountRole, index) in  accountRoles" :key="index">
                    <td id="colCustomerRoleRole">{{ accountRole.role }}</td>
                    <td id="colCustomerRoleCustomer">{{ accountRole.customer }}</td>
                    <td v-if="!readonly">
                        <a v-on:click="deleteAccountRole(index)"><delete-icon fillColor="#ff4d4d"/></a>
                    </td>
                </tr>
            </tbody>
            </table>
            </div>
        </div>
    </div>
</template>

<script>
import VueSingleSelect from "vue-single-select"
import axios from "axios"
import { getJwt } from "@/utils/auth.js"
import { toastInfo, toastError } from "@/utils/toast.js"
import PencilIcon from "vue-material-design-icons/pencil.vue"
import DeleteIcon from "vue-material-design-icons/delete.vue"
import { getApiUrl } from '@/utils/api.js'


export default {
    name: 'RoleEditor',
    components: {
        VueSingleSelect,
        PencilIcon,
        DeleteIcon
    },
    props: {
        accountRoles: Array,
        readonly: Boolean
    },
    data: function() {
        return {
            allCustomers: [],
            allRoles: [],
            selectedCustomer: null,
            selectedRole: null
        }
    },
    mounted: function() {

        this.loadData()
    },
    methods: {
        loadData: function() {

            axios({
                method: "GET",
                url: getApiUrl() + '/v0/accounts/roles',
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    this.allRoles = result.data
                },
                error => {
                    console.error(error.response.data.status)
                }
            );

            axios({
                method: "GET",
                url: getApiUrl() + '/v0/customers?size=1000',
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    result.data.data.map((customer) => {
                        this.allCustomers.push(customer.name)
                    });
                },
                error => {
                    console.error(error.response.data.status)
                }
            )
        },
        addCustomerRole: function() {

            if (this.selectedRole == null) {
                toastError("Es wurde keine Rolle ausgewählt!")
                return
            }
            if (this.selectedRole.startsWith('system.') && this.selectedCustomer != null) {
                toastError("Systemrollen könnem keinen Kunden zugeordnet werden!")
                return
            }
            if (this.selectedRole.startsWith('customer.') && this.selectedCustomer == null) {
                toastError("Kundenrollen müssen einem Kunden zugeordnet werden!")
                return
            }

            this.accountRoles.push({
                customer: this.selectedCustomer,
                role: this.selectedRole
            })
        },
        deleteAccountRole: function(index) {

            console.log(this.accountRoles[index].role + ' ' + this.accountRoles[index].customer)
            var copyArray = []
            
            for (var ii = 0; ii < this.accountRoles.length; ii++) {

                if (ii != index) copyArray.push(this.accountRoles[ii])
            }
            this.accountRoles.length = 0
            copyArray.map(item => this.accountRoles.push(item))

            this.$forceUpdate()
        }
    }
   
}
</script>

<style>

#inputId {
    height: 2rem;
}

#single-select {
    height: 2rem;
}

#role {
    width: 100%;
}

#addRoleBox {
    cursor: pointer;
    padding-left: 7px;
    padding-top: 9px;
}

#roleBox {
    padding-right: 7px;
}

#colCustomerRoleRole {
    width: 120px;
    height: 32px;
}

</style>
